import { getDiscounts, updateDiscount, createDiscount } from '../../../../api/suppliers';
import {
  GET_ALL_DISCOUNTS,
  UPDATE_DISCOUNT,
  UPDATE_DISCOUNT_PENDING,
  CREATE_DISCOUNT,
  SUCCESS_UPDATED,
  SUCCESS_CREATED,
  BAD_LOAD,
  BAD_UPDATE,
  BAD_CREATE
} from '../../constants';
export default {
  async updateDiscountPending({ commit, state }, value) {
    commit(UPDATE_DISCOUNT_PENDING, value);
  },
  async getAllDiscounts({ commit, state }, payload) {
    try {
      commit(UPDATE_DISCOUNT_PENDING, true);
      const data = await getDiscounts(payload.distSupplier._id);
      commit(GET_ALL_DISCOUNTS, data);
    } catch (e) {
      commit(BAD_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_DISCOUNT_PENDING, false);
    }
  },
  async updateDiscount({ commit, state }, payload) {
    try {
      commit(UPDATE_DISCOUNT_PENDING, true);
      const data = await updateDiscount(payload.distSupplier._id, payload.discount);
      commit(UPDATE_DISCOUNT, data);
      commit(SUCCESS_UPDATED, null, { root: true });
    } catch (e) {
      commit(BAD_UPDATE, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_DISCOUNT_PENDING, false);
    }
  },
  async createDiscount({ commit, state }, payload) {
    try {
      commit(UPDATE_DISCOUNT_PENDING, true);
      const data = await createDiscount(payload.distSupplier._id, payload.discount);
      commit(CREATE_DISCOUNT, data);
      commit(SUCCESS_CREATED, '', { root: true });
    } catch (e) {
      commit(BAD_CREATE, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_DISCOUNT_PENDING, false);
    }
  }
};
